import ControllerBase from "@/app/shared/services/controllers/controllerBase";
import LogisticVariantStore from "../../../store/logisticVariantStore";

class logisticVariantController extends ControllerBase {
  constructor(baseUrl) {
    super();
    this.LogisticVariantStore = new LogisticVariantStore(baseUrl);
  }
}

export default logisticVariantController;
